import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const Account = () => {
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("orders");
  const [user, setUser] = useState({
    name: "",
    email: "",
    joined: "",
  });

  useEffect(() => {
    const isLoggedIn = sessionStorage.getItem("isLoggedIn") === "true";
    const userEmail = sessionStorage.getItem("userEmail");

    if (!isLoggedIn || !userEmail) {
      toast.error("Please login to access your account");
      navigate("/login");
    } else {
      // You can set a real user name if stored, otherwise fallback to email prefix
      const userName = userEmail.split("@")[0];
      const joinedDate = new Date().toLocaleDateString("en-US");

      setUser({
        name: userName.charAt(0).toUpperCase() + userName.slice(1),
        email: userEmail,
        joined: joinedDate,
      });
    }
  }, [navigate]);

  const handleLogout = () => {
    // ✅ Clear session data
    sessionStorage.removeItem("isLoggedIn");
    sessionStorage.removeItem("userEmail");

    // ✅ Notify user
    toast.success("Logged out successfully!");

    // ✅ Update header immediately
    window.dispatchEvent(new Event("sessionUpdated"));

    // ✅ Redirect home
    setTimeout(() => navigate("/"), 1000);
  };

  return (
    <section className="my-account-section">
      <div className="my-account-container">
        {/* --- Profile Header --- */}
        <div className="my-account-header">
          <div className="my-account-user">
            <div className="my-account-avatar">
              <span className="my-account-avatar-initial">
                {user.name ? user.name.charAt(0).toUpperCase() : "U"}
              </span>
            </div>
            <div className="my-account-info">
              <h3 className="my-account-name">{user.name || "User"}</h3>
              <p className="my-account-email">{user.email}</p>
              <span className="my-account-joined">Welcome Back</span>
            </div>
          </div>
          <button className="my-account-signout" onClick={handleLogout}>
            Sign Out
          </button>
        </div>

        {/* --- Navigation Tabs --- */}
        <div className="my-account-tabs">
          <button
            className={`my-account-tab ${
              activeTab === "orders" ? "active" : ""
            }`}
            onClick={() => setActiveTab("orders")}
          >
            🧾 Orders (0)
          </button>
          <button
            className={`my-account-tab ${
              activeTab === "wishlist" ? "active" : ""
            }`}
            onClick={() => setActiveTab("wishlist")}
          >
            ❤️ Wishlist (0)
          </button>
          <button
            className={`my-account-tab ${
              activeTab === "addresses" ? "active" : ""
            }`}
            onClick={() => setActiveTab("addresses")}
          >
            📍 Addresses
          </button>
        </div>

        {/* --- Main Content --- */}
        <div className="my-account-content">
          {activeTab === "orders" && (
            <div className="my-account-orders">
              <h4 className="my-account-subtitle">Order History</h4>
              <div className="my-account-empty">
                <div className="my-account-empty-icon">📦</div>
                <p className="my-account-empty-text">No orders yet</p>
                <p className="my-account-empty-subtext">
                  Start shopping to see your orders here.
                </p>
                <Link
                  to="/shop"
                  className="btn btn-outline-white d-inline-flex align-items-center gap-8"
                >
                  Start Shopping
                </Link>
              </div>
            </div>
          )}

          {activeTab === "wishlist" && (
            <div className="my-account-empty">
              <p>No items in your wishlist yet.</p>
            </div>
          )}

          {activeTab === "addresses" && (
            <div className="my-account-empty">
              <p>No addresses saved yet.</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Account;
